import {ModalService} from '../../services/modal.service';
import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {ModalComponent} from './modal.interface';
import {DialogButtonComponent} from '../buttons/dialog-button.component';
import {OrderService} from '../../services/order.service';
import {AuthService} from '../../services/auth.service';
import {TranslateService} from '../../services/translate.service';
import {SnackbarService} from '../../services/snackbar.service';
import {
  PaymentButtonButtonComponent,
  PaymentCardTitleComponent,
  PaymentSwishTitleComponent
} from '../buttons/payment-button.component';
import {firstValueFrom, Subject} from 'rxjs';
import {AppState} from '../../models/AppState';

@Component({
  standalone: true,
  imports: [
    DialogButtonComponent,
    PaymentButtonButtonComponent,
    PaymentSwishTitleComponent,
    PaymentCardTitleComponent
  ],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-80">
      <div class="p-4">
        <div class="flex justify-center mt-4">
          <app-payment-card-title [contrastTo]="'--theme-text'"></app-payment-card-title>
        </div>
        <div class="mt-8">
          <app-payment-button [text]="savedCardTitle" (onClick)="onSelect('saved_card')"></app-payment-button>
        </div>
        <div class="mt-4">
          <app-payment-button [text]="translate.getString('Annat kort')" (onClick)="onSelect('new_card')"></app-payment-button>
        </div>
        <div class="flex justify-end mt-8">
          <app-dialog-button [text]="translate.getString('Stäng')" (onClick)="close()"></app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class SelectCardDialogComponent implements ModalComponent {
  modalData!: any;
  savedCardTitle: string;

  constructor(
    private modalService: ModalService, protected translate: TranslateService,
    @Inject('MODAL_DATA') public data: {
      cardNumber: string;
      onSelect(s: string): void;
    }
  ) {
    this.modalData = data;
    this.savedCardTitle = `${translate.getString("Sparat kort")} (${data.cardNumber})`;
  }

  close() {
    this.modalService.close();
  }

  onSelect(s: string) {
    this.modalData.onSelect(s);
    this.close();
  }

  static showSelectCardDialog(modalService: ModalService, appState: AppState) {
    const hasSavedCard = appState.order.user_cfg.payment?.saved_card;
    if (hasSavedCard == null) {
      return Promise.resolve("new_card");
    }

    const subject = new Subject<string>();
    modalService.show(SelectCardDialogComponent, {
      data: {
        cardNumber: appState.order.user_cfg.payment?.saved_card,
        onSelect: (s: string) => {
          subject.next(s);
          subject.complete();
        },
      }
    });
    return firstValueFrom(subject);
  }

}
